import classNames from 'classnames'
import { useTranslation } from 'react-i18next'
import { NavLink } from 'react-router-dom'
import styles from '../GenericNavigation/generic-navigation.module.scss'
import BupSpinner from '@BUP/components/Loading/Spinner'
import { useGetResultsSociogram } from '@BUP/hooks/Sociogram/useGetResultsSociogram'
import { useContext } from 'react'
import { CurrentTermContext } from '@BUP/contexts/CurrentTermContext'

const WorkGroupSubNavLink = () => {
  const { t } = useTranslation()
  const term = useContext(CurrentTermContext)

  const {
    organizationResults,
    isLoadingResultsSociogram,
    errorResultsSociogram
  } = useGetResultsSociogram(term.id)

  if (isLoadingResultsSociogram) return <BupSpinner size='small' revert />
  if (!organizationResults || errorResultsSociogram) return null

  return (
    <NavLink
      className={styles.sub_nav_link}
      activeClassName={classNames(`${styles.active}`, 'active')}
      to={{
        pathname: '/work-group-page',
        state: { organizationResults }
      }}
    >
      <span className={styles.nav_label}>{t('nav.groupWork')}</span>
    </NavLink>
  )
}

export default WorkGroupSubNavLink
